import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { manageCarrierServiceOptions } from './constants'

const ManageCarrierServiceSelector = ({ value, onChange, disabled }) => {
  const { t } = useTranslation()
  return (
    <ComboBox
      label={t('Gestión del servicio de logística')}
      value={value}
      menuItems={manageCarrierServiceOptions.map(option => ({
        label: t(option.label),
        value: option.value,
      }))}
      handleChange={e => onChange(e.target.value)}
      fullWidth
      disabled={disabled}
    />
  )
}

export default ManageCarrierServiceSelector
